module.exports = __webpack_public_path__ + "img/flecha.7bb8b074.svg";